import { Hidden, HStack, Pressable, Stack, Text, useDisclose, useMediaQuery, VStack } from 'native-base';
import React, { memo, useContext, useEffect, useMemo } from 'react';
import IconButton from '../../IconButton';
import MessageRow from '../../MessageRow';
import { UploadCloudIcon } from '../../../assets';
import BorderedCard from '../../BorderedCard';
import AvatarIcon from '../../AvatarIcon';
import CloseIcon from '../../../assets/icons/Close';
import CaretDownIcon from '../../../assets/icons/CaretDown';
import { UserDetailsContext } from '../../../containers/NewLoanInProgress';
const TrackingItem = _ref => {
  let {
    title,
    detail,
    infoText,
    itemIndex,
    setSelected,
    isDisabled,
    opacity,
    sectionIndex,
    color,
    render,
    data,
    logUserEvent,
    status
  } = _ref;
  const {
    isOpen,
    onOpen,
    onClose
  } = useDisclose(false);
  const [isSmallScreen] = useMediaQuery({
    maxWidth: 768
  });
  const handleOpen = () => {
    console.log('handleOpen');
    logUserEvent({
      action: `${title.split(' ').join('')}Clicked`,
      type: 'NewLoanInProgress',
      description: `${title.split(' ').join('')} - ${isOpen ? 'Closed' : 'Opened'}`
    });
    if (isOpen) {
      onClose();
      setSelected('');
      return;
    }
    onOpen();
    setSelected(`${title}-${itemIndex}`);
  };
  useEffect(() => {
    logUserEvent({
      action: `${title.split(' ').join('')}Displayed`,
      type: 'NewLoanInProgress'
    });
  }, [logUserEvent, title]);
  const {
    borderColor
  } = useContext(UserDetailsContext);
  const border = useMemo(() => {
    if (status && (status === 'Pre UW Incomplete' || status === 'Pre gate Incomplete')) return '#D63D34';
    return borderColor;
  }, [status, borderColor]);
  return /*#__PURE__*/React.createElement(BorderedCard, {
    border: border,
    isOpen: isOpen,
    opacity: opacity,
    mb: "3",
    pl: "3",
    py: "3",
    pr: "8"
  }, /*#__PURE__*/React.createElement(Pressable, {
    onPress: handleOpen,
    isDisabled: isDisabled
  }, /*#__PURE__*/React.createElement(Stack, {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: {
      lg: isOpen && sectionIndex === 0 ? 'flex-start' : 'center',
      md: isOpen && sectionIndex === 0 ? 'flex-start' : 'center',
      base: 'center'
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: {
      lg: isOpen && sectionIndex === 0 ? 'flex-start' : 'center',
      md: isOpen && sectionIndex === 0 ? 'flex-start' : 'center',
      base: 'center'
    },
    flex: 2,
    space: 4
  }, /*#__PURE__*/React.createElement(AvatarIcon, {
    name: title
  }), /*#__PURE__*/React.createElement(VStack, {
    pt: {
      md: isOpen && sectionIndex === 0 ? 6 : 0,
      lg: isOpen && sectionIndex === 0 ? 6 : 0
    },
    space: 2,
    maxW: "80%"
  }, /*#__PURE__*/React.createElement(Text, {
    fontFamily: "body",
    fontWeight: "medium",
    fontSize: "sm",
    lineHeight: "2xs",
    color: "text.running",
    opacity: opacity,
    accessibilityLabel: title,
    testID: title
  }, title, ' ', sectionIndex === 1 && Array.isArray(data) ? `(${data.length})` : ''), sectionIndex === 1 ? null : /*#__PURE__*/React.createElement(Hidden, {
    till: "md"
  }, /*#__PURE__*/React.createElement(VStack, {
    space: 3
  }, !detail ? null : /*#__PURE__*/React.createElement(Text, {
    fontSize: "sm",
    fontWeight: "normal",
    fontFamily: "body",
    color: "black.700",
    opacity: opacity,
    display: isSmallScreen ? 'none' : 'flex',
    accessibilityLabel: detail,
    testID: detail
  }, detail), infoText ? /*#__PURE__*/React.createElement(MessageRow, {
    text: infoText,
    color: color,
    opacity: opacity,
    maxW: isSmallScreen ? 185 : undefined
  }) : null)))), (isSmallScreen || sectionIndex === 1) && !isOpen ? /*#__PURE__*/React.createElement(Pressable, {
    onPress: handleOpen,
    isDisabled: isDisabled,
    accessibilityLabel: `open ${title}`,
    testID: `open ${title}`,
    opacity: opacity
  }, /*#__PURE__*/React.createElement(CaretDownIcon, null)) : /*#__PURE__*/React.createElement(ToggleButton, {
    isOpen,
    onClose,
    setSelected,
    isDisabled: isDisabled,
    handleOpen,
    isSmallScreen,
    title
  }))), isOpen ? render(data, title, sectionIndex, detail, isSmallScreen) : null);
};
export default /*#__PURE__*/memo(TrackingItem);
const ToggleButton = _ref2 => {
  let {
    isOpen,
    onClose,
    setSelected,
    isDisabled,
    handleOpen,
    isSmallScreen,
    title
  } = _ref2;
  return isOpen ? /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => {
      onClose();
      setSelected('');
    },
    accessibilityLabel: `close ${title}`,
    accessibilityRole: "button",
    testID: `close ${title}`
  }, /*#__PURE__*/React.createElement(CloseIcon, null)) : /*#__PURE__*/React.createElement(IconButton, {
    isDisabled: isDisabled,
    _disabled: {
      bg: '#425364'
    },
    onPress: handleOpen,
    title: 'Upload',
    Icon: /*#__PURE__*/React.createElement(UploadCloudIcon, null),
    display: isSmallScreen ? 'none' : 'flex',
    accessibilityLabel: `upload ${title}`,
    testID: `upload-${title}`
  });
};
//# sourceMappingURL=index.js.map